/* eslint-disable sort-keys */

export default {
    Menu: {
        parts: [
            "item",
            "command",
            "list",
            "button",
            "groupTitle",
            "divider"
        ],
        baseStyle: {},
        sizes: {},
        variants: {
            default: {
                item: {
                    px: "4",
                    py: "3",
                    fontSize: "p2",
                    _hover: {
                        bg: "secondary.100",
                        color: "primary.700",
                    },
                    _focus: {
                        bg: "secondary.100",
                        color: "primary.700",
                    }
                },
                list: {
                    p: "0",
                    borderColor: "secondary.100"
                }
            },
            minimalOutlined: {
                item: {
                    px: "4",
                    py: "3",
                    fontSize: "p2",
                    _hover: {
                        bg: "secondary.100",
                    },
                    _focus: {
                        bg: "secondary.100",
                    }
                },
                list: {
                    border: "thinLight",
                }
            }
        },
        defaultProps: {},
    }
};
